<template>
  <div>
    <b-modal
      ref="modalInstrumento"
      size="xl"
      scrollable
      title="Verificação de Autenticidade"
      id="modal-dialog"
    >
      <pdf :src="pdf" style="width:100%"></pdf>
    </b-modal>
    <b-modal 
      v-if="!$root.isDevice"
      ref="AlertaAviseme"
      size="xl"
      scrollable
      id="modal-dialog-home-aviseme"
      class="modal-dialog-home-aviseme"
    >
      <a href="/cadastro"><img class="modal-avise-me" src="@/assets/imgs/alerta_aviseme.jpg"/></a>
    </b-modal>
    <b-modal 
  ref="WarningModal"
  size="lg"
  scrollable
  id="modal-warning"
  class="modal-warning"
>
  <template #modal-title>
    <b-icon icon="exclamation-triangle-fill" variant="danger" class="mr-2"></b-icon>
    Aviso Importante
  </template>

  <div class="text-center p-3">
    <b-icon icon="telephone-x-fill" variant="danger" font-scale="2" class="mb-3"></b-icon>
    <p class="mb-3">
      Informamos que, devido a uma <strong>instabilidade temporária</strong> em nossa linha telefônica, 
      o atendimento será realizado exclusivamente por e-mail.
    </p>
    
    <b-icon icon="envelope-fill" variant="primary" class="mr-2"></b-icon>
    <strong class="text-primary">consultaprotesto@cartoriosdeprotesto.org.br</strong>
  </div>

  <template #modal-footer>
    <b-button variant="primary" class="px-4" @click="$refs.WarningModal.hide()">
      <b-icon icon="check-circle-fill" class="mr-2"></b-icon>Entendido
    </b-button>
  </template>
</b-modal>


    <b-modal ref="modalErro" title="Atenção">{{msgValida}}</b-modal>
    <!-- <div class="toaster" :class="{'active': toaster}" id="toaster" ref="toaster">
      <div class="close" @click="toaster = !toaster">X</div>
      <a @click="redirectBanner">
        <img class="toast-banner" src="~@/assets/imgs/banners/banner-premio-ra-2024.jpeg">
      </a>
    </div> -->
    <protestoanuenciacancelamento  :itemsp="items" v-if="tabSelecionado == 2 && items.length > 0 "/>
      <!-- {{item != undefined ? item.length : ''}} -->
    <editaleletronico  :itemsp="items" v-if="tabSelecionado == 3 && items.length > 0 "/>

    <div id="consulta-form" v-bind:class="totem ? 'd-block column-nowrap layout_totem' : 'd-block column-nowrap'">
        <div id="banner1">
          <div id="textoBannerHome">
            <h1>Cartórios de <strong>Protesto</strong></h1>
            <h2 class="subtitulo-home">A maneira mais fácil de recuperar seu crédito</h2>
          </div>

          <consultaprotesto id="consulta-card" :totem="totem"></consultaprotesto>
          <div class="banner1-outros-servicos-mobile-container">
            <div class="banner1-outros-servicos-mobile">
              <!-- <b-button href="#nossos-servicos" class="btn-maisservicos">+ Mais serviços</b-button> -->
            </div>
          </div>
        </div>
        <nossosservicos id="nossos-servicos" class="d-block"  v-if="totem == 0" />
        <!-- <nossosservicosmobile id="nossos-servicos" class="d-sm-none" style="margin-top:100px;" /> -->
        <conhecavantagens id="conheca-vantagens" :home="true" v-if="totem == 0" /> 
        <!-- <ultimaspublicacoes id="ultimas-publicacoes-home"  v-if="totem == 0"/> -->
        <faleconosco  id="fale-conosco" v-if="totem == 0" />
        <!-- <depoimentoclientes class="d-block"/> -->
        <!-- <depoimentoclientesmobile class="d-sm-none" /> -->
        
    </div>
  </div>
</template>

<script>
import API from "../../services/api";
import consultaprotesto from "../../components/consulta_protesto";
import nossosservicos from "../../components/nossos_servicos";
import nossosservicosmobile from "../../components/nossos_servicos/index_mobile";
import depoimentoclientes from "../../components/depoimento_clientes";
import depoimentoclientesmobile from "../../components/depoimento_clientes/index_mobile";
import cartoriosnamidia from "../../components/cartorios_na_midia";
import cartoriosnamidiamobile from "../../components/cartorios_na_midia/index_mobile";
import ajuda from "../../components/ajuda";
import ajudamobile from "../../components/ajuda/index_mobile";
import footersite from "../../components/footersite";
import footersitemobile from "../../components/footersite/index_mobile";
import protestoanuenciacancelamento from "../../components/protesto_anuencia_cancelamento";
import editaleletronico from "../../components/edital_eletronico";
import contato from "../../components/contato";
import conhecavantagens from "../../components/conhecavantagens";
import ultimaspublicacoes from "../../components/ultimaspublicacoes";
import faleconosco from "../../components/faleconosco";

//import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import VueRecaptcha from "vue-recaptcha";
import { TheMask } from "vue-the-mask";
import pdf from "vue-pdf";

export default {
  props:['totem'],
  components: {
    // BeatLoader,
    VueRecaptcha,
    consultaprotesto, 
    nossosservicos,
    nossosservicosmobile,
    depoimentoclientes,
    depoimentoclientesmobile,
    cartoriosnamidia,
    cartoriosnamidiamobile,
    ajuda,
    ajudamobile,
    footersite,
    footersitemobile,
    TheMask,
    pdf,
    protestoanuenciacancelamento,
    editaleletronico,
    contato,
    conhecavantagens,
    ultimaspublicacoes,
    faleconosco
  },
  data() {
    return {
      dismissSecs: 4,
      dismissCountDown: 0,
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,
      cpf_cnpj: "",
      logged: false,
      documento: "",
      items: [],
      tok: "",
      exibir: false,
      tabSelecionado:1,
      pdf:'',
      tipoServico:1,
      msgValida:'',
      toaster: false,
    };
  },
  computed: {
    descricaoInput : function(){
       return this.tabSelecionado == 4 ? 'Digite sua chave' : 'Digite o número do CPF ou CNPJ'
    },
    tamanhoImg : function() {
      return this.totem ? '100vh' : '590px';
    },
    bordaImg:function(){
      return this.totem ? '0px' : '308px';
    },
    alturaTexto : function() {
      return this.totem ? '19vh' : '';
    }
  },
  mounted() {
    this.$root.isLogged().then(() => {
      this.logged = true;
    }).catch(() => {
      this.logged = false;
        setTimeout(() =>{
          this.$refs['AlertaAviseme'].show();
        },1)
    });
    setTimeout(() => {
      this.toaster = true;
      setTimeout(() => {
        this.toaster = false;
      }, 8000);
    }, 1000);
  },
  created(){
  },
  filters: {
    moeda: function (value) {
      var v = value.replace(/\D/g,'')
      v = (v/100).toFixed(2) + ''
      v = v.replace(".", ",")
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,")
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,")
      return v
    },
    uppertitulo: function (value){
      if (!value) return ''
      value = value.toString()
      var vall = value.toLowerCase()
      return vall.charAt(0).toUpperCase() + vall.slice(1)
    },
    uppert: function (value){
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    },
    dataBr: function (value) {
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      //console.log(strSplit);
      return dia +"/"+ mes +"/"+ ano ;
    },
    SomadataBr: function (value) {
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      var data  = new Date(ano, mes, dia);
      data.setDate(data.getDate() + 3);
      var diaf=data.getDate();
      var mesf=data.getMonth();
      var anof=data.getFullYear();
      var minhaData = diaf + '/' + mesf + '/' + anof;

      return minhaData;
    },
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    documento: function (value) {
      if (value == null) {
          return '';
      } else {
          let v = value;
          //Remove tudo o que não é dígito
          v = v.replace(/\D/g, "");
          if (v.length < 14) { //CPF
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
          } else { //CNPJ
              v = v.replace(/^(\d{2})(\d)/, "$1.$2");
              v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
              v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
              v = v.replace(/(\d{4})(\d)/, "$1-$2");
          }
          return v;
      }
    }
  },
  methods: {
    openWarningModal() {
      this.$refs.WarningModal.show();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    servicoSelecionado(res)
    {
      this.alteracaoTab(res)
    },
    alteracaoTab(numeroTab){
      this.tabSelecionado = numeroTab
    },
    limparInput() {
      document.getElementById('cpf_cnpj').value="";
      document.getElementById("cpf_cnpj").focus()
  },
    hideModal() {
        this.$refs['modalErro'].hide();
      },
      hideModal2() {
        this.$refs['modalInstrumento'].hide();
      },
    //desableRC: function(e) {
    confirmar(){
      document.getElementById("cpf_cnpj").focus()
    },
    onVerify: function(response) {
      this.tok = response;
    },
    validarCPF(str) {
        var Soma;
        var Resto;
        Soma = 0;
        if (str == "00000000000") return false;
        for (let i=1; i<=9; i++)
            Soma = Soma + parseInt(str.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(str.substring(9, 10)) ) return false;
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(str.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(str.substring(10, 11) ) ) return false;
        return true;
    },
    validarCNPJ(str) {
        str = str.replace('.','');
        str = str.replace('.','');
        str = str.replace('.','');
        str = str.replace('-','');
        str = str.replace('/','');
        let cnpj = str;
        var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
        digitos_iguais = 1;
        if (cnpj.length < 14 && cnpj.length < 15)
            return false;
        for (let i = 0; i < cnpj.length - 1; i++)
            if (cnpj.charAt(i) != cnpj.charAt(i + 1))
        {
            digitos_iguais = 0;
            break;
        }
        if (!digitos_iguais)
        {
            tamanho = cnpj.length - 2
            numeros = cnpj.substring(0,tamanho);
            digitos = cnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != digitos.charAt(0))
                return false;
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != digitos.charAt(1))
                return false;
            return true;
        }
        else
            return false;
    },
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    solicitar(nm_chave, cpfCnpj) {
      if(nm_chave) {
        if(this.validar()){
          //  iniciando solicitação -> login / cadastro
          //  armazena a chave
          localStorage.setItem("nm_chave", nm_chave)
          localStorage.setItem("cpfCnpj", cpfCnpj)
          //  redireciona para login
          this.$router.push({ name: 'login', params: { tipo_login: 'solicitarCancelamentoAnuencia' } })
        } else {
          alert('informe o cpf')
        }
      }
    },
    enviarConsultaAnuencia() {
      this.$refs.invisibleRecaptcha.execute();
    },
    validar() {
      let len = this.cpf_cnpj.length;
      //let doc = this.cpf_cnpj
      return len == 11 || len == 14 ? true : false;
      //return len == 11 ? Serv.validarCPF(doc) : len == 14 ? Serv.validarCNPJ(doc) : false
    },
    placeholderInputConsulta(show) {
      let placeholder = document.getElementById("cpf_ou_cnpj");
      if (show) placeholder.classList.remove("hide");
      else placeholder.classList.add("hide");
    },
    verificaInputConsulta() {
      if (!this.cpf_cnpj) this.placeholderInputConsulta(true);
    },
    inputConsultaFocus() {
      document.getElementById("cpf_cnpj").focus();
    },
    consultar() {
      //this.$refs.invisibleRecaptcha.execute();
      if(this.tok == '' || this.tok == undefined) {
        this.dismissCountDown = this.dismissSecs
      } else if(this.tabSelecionado == 1)
      {
        let documento = this.cpf_cnpj
        let response = this.tok
        //console.log(response)
        if(response != ''){
          if(this.validar()) {  
              if(documento.length == 11){
                  if(!this.validarCPF(documento)){
                  this.$refs["modalErro"].show();
                  this.msgValida = 'CPF INVÁLIDO'
                  this.exibir = true
                  
                  return false
                }
              }
              if(documento.length == 14){
                  let documentoTronco = documento.substr(0,8)
                  if(!this.validarCNPJ(documento))
                  {
                    this.$refs["modalErro"].show();
                    this.msgValida = 'CNPJ INVÁLIDO'
                    this.exibir = true
                    
                    return false
                  }
                  else if(documentoTronco == '00360305')
                  {
                    this.$refs["modalErro"].show();
                    this.msgValida = 'Consulta Bloqueada '
                    this.exibir = true
                    
                    return false
                  }
              }
            this.$router.push({ name: 'consulta', params: { documento: documento, captcha: this.tok, totem: this.totem } })
          }else{
              this.$refs["modalErro"].show();
              this.msgValida = 'CPF OU CNPJ INVALIDO!'
              this.exibir = true
              
              return false
          }
        }
      }
      else if(this.tabSelecionado == 2){
        if (this.cpf_cnpj) {
          let self = this;
          API.get(`/pesquisa/tituloanuencia/${this.cpf_cnpj}/${this.tok}`)
            .then(res => {
                  if(res.data.result == 1){
                      self.items = res.data['instrumentoProtesto'];
                      self.items = res.data['instrumentoProtesto'];
                      setTimeout(() => {
                        self.$bvModal.show('modal-anuecia-cancelamento');
                      }, 0);
                      this.exibir = false;
                  }else {
                      this.$refs["modalErro"].show();
                      this.exibir = false;
                  }
            })
            .catch(()=> {
              //console.log(e);
              alert("Não foi possivel completar a solicitação");
              this.exibir = false;
            });
        }
      }
      else if(this.tabSelecionado == 3){
        if (this.cpf_cnpj) 
        {
          let self = this;
          this.exibir = false;
          API.get(`/pesquisa/pesquisaEditalEletronico/${this.cpf_cnpj}/${this.tok}`)
            .then(res => {
                  if(res.data.result == 1){
                      self.items = res.data['editalEletronico'];
                      self.items = res.data['editalEletronico'];
                      setTimeout(() => {
                        self.$bvModal.show('modal-edital-eletronico');
                      }, 0);
                      this.exibir = false;
                  }else {
                      this.msgValida = 'Nenhum registro encontrado'

                      this.$refs["modalErro"].show();
                      this.exibir = false;
                  }
            })
            .catch(()=> {
              //console.log(e);
              alert("Não foi possivel completar a solicitação");
              this.exibir = false;
            });
        }
      }
      else if(this.tabSelecionado == 4){
        if (this.cpf_cnpj) {
                //this.exibir = true;
                API.get(`VerifInstProt/${this.cpf_cnpj}/${this.tok}/${this.tipoServico}`)
                  .then(res => {
                        if(res.data.result == 1){
                          if(this.tipoServico == 2 )this.pdf = res.data.instrumentoProtesto;
                          else this.pdf = "data:application/pdf;base64," + res.data.instrumentoProtesto;
                          this.$refs["modalInstrumento"].show();
                            //this.exibir = false;
                        }else {
                            this.$refs["modalErro"].show();
                            //this.exibir = false;
                        }
                  })
                  .catch(()=> {
                    //console.log(e);
                    alert("Não foi possivel completar a solicitação");
                    this.exibir = false;
                  });
        }
      }
    },
    redirectBanner(){
      // window.open('https://www.reclameaqui.com.br/premio/votacao', '_blank');
    }
  }
};
</script>

<style scoped>
.toaster{
  display: flex;
  width: fit-content;
  height: fit-content;
  position: fixed;
  z-index: 1000;
  bottom: 200px;
  right: -600px;
  transition: all 0.45s ease-in;
}
.toaster.active{
  right: 0px;
}
.toaster .close{
  background: #4780F1;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font: normal normal bold 15px/15px 'Kanit', sans-serif;
  padding-bottom: 2px;
  color: white;
  opacity: 1;
  position: absolute;
  margin-left: -40px;
  box-shadow: 0px 0px 11px 0px #00000080;
  cursor: pointer;
}
.toast-banner{
  width:100%;
  height: 100%;
  box-shadow: 0px 0px 11px 0px #00000080;
  border-radius: 19px 0 0 19px;
  cursor:pointer;
}
.banner1-outros-servicos-mobile-container{display: none;width: 100%;background-color: white;}

#consulta-form {
  font-family: 'Kanit', sans-serif;
  text-transform: uppercase;
}
#banner1 {
  /* display: flex; */
  background-repeat: no-repeat;
  background-position: left center;
  /* justify-content: center; */
  /* flex-direction: column; */
  /* background-image: url("~@/assets/imgs/header-mobile.png"); */
  height: 100%;
  /* border-top: 3px solid transparent; */
  background-position: center;
  background-size: cover;
  /* margin-bottom: 45px; */
  /* padding-top: 75px; */
  /* background-image: linear-gradient(45deg, rgba(8, 79, 132, 0.8), rgba(8, 79, 132, 0.3)), url("~@/assets/imgs/header-mobile.png"); */
}
/*MELHORIA*/
#banner1 .container-radio-consulta{
  /* left: 18px;
  max-width: 80vw; */
  padding-left: 24px;
  flex:unset;
  margin-bottom:15px;
  margin-left: unset;
}
#banner1:after{
  content:'';
  width:20px;
  height:20px;
  border-width: 4px 4px 0 0;
  border-style: solid;
  border-color: white;
  transform: rotate(135deg);
  align-self: center;
  position:absolute;
  top:88vh;
  left: calc(50vw - 10px);
  animation: homeCallerAnimation 4s infinite;
}
@keyframes homeCallerAnimation{
  0%, 25% {
    transform:rotate(135deg) translateY(0%) translateX(0%);
    opacity:1;  
  }
  60%{
    transform:rotate(135deg) translateY(-120%) translateX(120%);
    opacity:0.8;
  }
  90% {
    transform:rotate(135deg) translateY(-200%) translateX(200%);
    opacity:0;
  }
  91%{
    transform:rotate(135deg) translateY(0%) translateX(0%);
    opacity:0;
  }
  100%{
    transform:rotate(135deg) translateY(0%) translateX(0%);
    opacity:1;
  }
}
#textoServico{
  margin-top: calc(3%);
}
.div_bt_consultar{
  text-align : left;
  position: absolute;
  flex: unset;
  max-width: unset;
  width: calc((100% - 0.75rem)/4);
  display: flex;
  z-index: 10;
  right: 0;
  top: 0;
  height: inherit;
  padding: 0;
}
#input_cpf_cnpj { 
  width: 100%;
  border: none;
  font-size: 15px; 
  box-shadow: 0 0 0 0;
  outline: 0;
  padding-left: 2px;
  line-height:40px;
  text-align: left;
  border-bottom-left-radius:6px;
  border-bottom-right-radius: 6px;
  height: inherit;
}
.bt-consultar{
  /* font-family: arial; */
  font-family:'Kanit', sans-serif;
  font-size: 20px;
  /* width: 28vw; */
  /* height: 42px; */
  /* background-color: rgb(63,201,255); */
  /* color:white; */
  border: none;
  /* margin-left:63px; */
  /* border-top-right-radius:6px;
  border-bottom-right-radius: 6px; */
  flex: unset;
  max-width: unset;
  background-color: transparent;
  color: rgb(64,67,67);
  opacity:0.5;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
}
.bt-consultar:before{
  content: '';
  height: 42%;
  border-right: 1px solid rgb(64,67,67);
  align-self: center;
  margin-right: 22px;
  opacity: 0.5;
  margin-right: 15%;
  margin-left: 3%;
}
.bt-consultar:hover, .bt-consultar:active {
  color: #2065c0;
  font-weight:bold;
  opacity: 1;
}

.bt-consultar:hover::before, .bt-consultar:active::before {
  border-color: #2065c0;
  opacity: 1;
}
.textoRealizarServicos
{
  font-family: 'Kanit', sans-serif;
  text-transform: uppercase;
  color: #084f84;
  color:white;
  font-size: 29px;
  line-height: 25px;
  /* margin-right: 500px; */
  text-align: left;
  font-weight: 700;
}
#banner1 .container-input-consulta {
  display:flex;
  flex-flow:column;
  font-family: 'Kanit', sans-serif;
}
#banner1 .container-input-consulta > .row {
  margin: unset !important;
  margin-bottom: 15px !important;
}
#banner1 .container-input-consulta .row > div:first-child {
  margin: unset !important;
  width: 80vw;
  max-width: 885px;
  flex: unset;
  height: 56px;
}


@media (min-width: 900px) {
  /* .bt-consultar{
    font-size:18px;
    width: 17.4vw;
    height: 56px;
    background-color: rgb(63,201,255);
    color:white;
    border: none;
    /* margin-left:63px; */
  /*border-top-right-radius:6px;
    border-bottom-right-radius: 6px;
  } */
  .textoRealizarServicos
  {
    color: #084f84;
    color: white;
    font-size: 39px;
    padding:2px;
    /* margin-right: 500px; */
    text-align: left;
    line-height: 40px;
  }
  #input_cpf_cnpj { 
    font-size: 23px; 
    padding-left: 60px;
    line-height: 54px;
  }
  #banner1 {
    background-image: linear-gradient(45deg, rgba(8, 79, 132, 0.8), rgba(8, 79, 132, 0.3)), url("~@/assets/imgs/header.png");
    display: flex;
    flex-flow: column;
    /* height: 800px; */
  }
  #banner1 .mt-5{
    margin: 1rem 0 0 0 !important;
  }
  #banner1 .container-radio-consulta .combo-radio-consulta{
    display:flex;
    flex: unset;
  }
  #banner1 .container-radio-consulta .textoConsulta{
    display:flex;
    flex:unset;
    align-items:center;
  }
  #banner1 .container-radio-consulta .textoConsulta label *{
    top: -3px;
    position: relative;
  }
  #textoServico{
    margin-top: calc(7%);
  }
}

.textoConsulta{
  color: #084f84;
  color: white;
  font-size: 20px;
  padding:4px;
  /* margin-right: 500px; */
  text-align: left;
}
.item {
  /* O flex: 1; é necessário para que cada item se expanda ocupando o tamanho máximo do container. */
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}

@media (min-width: 320px) and (max-width: 765px) {
   #textoServico{
    margin-top: calc(1%);
  }
   .textoRealizarServicos{
  /* margin-top: 150px; */
  /* margin-left: 60px; */
    font-size: 1rem;
    margin-bottom: 0;
    letter-spacing: 0.01rem;

 }
  #banner1{
    height: 100%;
    width: 100%;
    display: flex; /*ADICIONADO*/
    flex-flow: column; /*ADICIONADO*/
    justify-content: flex-start; /*ADICIONADO*/
  }
  
  #consulta-form .mt-5{
    margin-top: 1rem !important;
  }
  #consulta-form #radio-group-2{
    display:flex;
    justify-content:space-between;
    flex-flow:column;
  }
  #consulta-form #radio-group-2 .textoConsulta{
    font-size: 1rem;
    margin:0px !important;
  }

  #textoServico .textoConsulta{
    margin-top: 1.75rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 1199px) {

  #banner1 .container-input-consulta .row > div:first-child{
    max-width: unset;
    width: 100%;
  }
  .bt-consultar{
    justify-content: end;
    padding-right: 1rem;
  }
  .bt-consultar:before, .bt-consultar b{
    display:none;    
  }
  #input_cpf_cnpj{
    font-size: 1.2rem;
    padding-left: 1rem;
  }
  .container-radio-consulta .mt-5{
    margin-top: 1rem !important;    
    margin-left: 0px !important;
  }
}
 /*FIM MELHORIA*/
 @media (max-width: 780px){
  
  .banner1-outros-servicos-mobile-container{display: flex;justify-content: center;}
    .banner1-outros-servicos-mobile-container .banner1-outros-servicos-mobile{width: 335px;margin: auto;}
      .banner1-outros-servicos-mobile-container .banner1-outros-servicos-mobile .btn-maisservicos{ width: 177px;height: 44px;background-color: #1ACEB5;border-radius:5px;font: normal normal bold 15px/20px 'Kanit', sans-serif;color: white;text-transform: none;border:unset; display: flex;justify-content: center;align-items: center;}

 }
.layout_totem{
  margin-top: 0px !important;
  /* font-size: 10px; */
  
}
#consulta-form #banner1{
  height: v-bind(tamanhoImg) !important;
  margin-bottom: v-bind(bordaImg);
}

.modal-avise-me{
  width: 100%;
  height: auto;
  /* background-image: url("~@/assets/imgs/alerta_aviseme.jpg"); */
  /* background-repeat: no-repeat; */
}
@media (max-width: 991px){
  .modal-avise-me{
    width: 205%;
  }
}
</style>